<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title87"></a>
<div class="p-c-br"><span>To the memory of my friend and colleague, <br/>the star-seeker Robert Forward; <br/>and to A.D., of course; <br/>but most of all to the beauteous Barbara.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429910613_ded01.vue?95b3561c